// extracted by mini-css-extract-plugin
export default {"root":"MobileColumn2_root__FntDB","bottom":"MobileColumn2_bottom__U7esD"};